import React, {useRef, useEffect} from 'react'
import {Typography, TextField, InputAdornment, Grid, withStyles} from '@material-ui/core'

import InfoTooltip from '../../common/InfoTooltip'
import DeleteButton from '../../common/DeleteButton'
import AddButton from '../../common/AddButton'
import useModalState from '../../../hooks/useModalState'
import styles from '../styles/TestSetup.styles'

const FaultPercentageOptions = ({
  classes,
  question,
  disableInputs,
  maxAnswers,
  addChoice,
  removeChoice,
  validateFields,
  currentQuestion,
  setChoice,
  choiceErrors,
}) => {
  const [isMaxAnswersTooltipOpen, openMaxAnswersTooltip, closeMaxAnswersTooltip] = useModalState(
    false,
  )

  const lastChoiceInputRef = useRef(null)

  useEffect(() => {
    if (lastChoiceInputRef.current) {
      lastChoiceInputRef.current.scrollIntoView({behavior: 'smooth'})
    }
  }, [question.choices])

  const getInputRef = index => {
    if (index === question.choices.length - 1) {
      return {
        inputRef: ref => {
          lastChoiceInputRef.current = ref
        },
      }
    }

    return {}
  }

  const renderChoices = () => {
    return question.choices.map((choice, index) => (
      <TextField
        {...getInputRef(index)}
        key={index}
        value={choice}
        onChange={({target}) => {
          setChoice(target.value.trimStart(), index)
          validateFields(currentQuestion)
        }}
        variant="outlined"
        className={classes.nameInput}
        InputProps={{
          classes: {
            root: classes.nameInputOutline,
            notchedOutline: choiceErrors[index] ? classes.errorOutline : classes.notchedOutline,
          },
          endAdornment: !disableInputs ? (
            <InputAdornment position="end">
              <DeleteButton
                onClick={() => removeChoice(index)}
                disabled={question.choices.length <= 2}
              />
            </InputAdornment>
          ) : null,
          readOnly: disableInputs,
          onBlur: () => {
            setChoice(choice.trim(), index)
            validateFields(currentQuestion)
          },
        }}
        placeholder="Enter party name"
        helperText={choiceErrors[index]}
        FormHelperTextProps={{
          className: classes.inputErrorText,
          errormessage: 'true',
        }}
        disabled={disableInputs}
      />
    ))
  }

  return (
    <>
      <Typography variant="h6" className={classes.sectionTitle} style={{width: 'max-content'}}>
        Parties
        <InfoTooltip
          text={
            <div>
              <span>Fault Percentage Assignment:</span>
              <ul style={{margin: '8 8 0 0', paddingLeft: 20, lineHeight: '24px'}}>
                <li>Panelists will assign fault percentages to each party</li>
                <li>Example: &quot;Assign fault percentage for the vehicle collision&quot;</li>
                <ul>
                  <li>Driver A</li>
                  <li>Driver B</li>
                  <li>City of Springfield</li>
                </ul>
              </ul>
            </div>
          }
          placement="right"
        />
      </Typography>
      {renderChoices()}
      {!disableInputs && (
        <Grid container style={{alignItems: 'center'}}>
          {question.choices.length >= maxAnswers ? (
            <InfoTooltip
              text={`You can only add a maximum of ${maxAnswers} parties.`}
              placement="left"
              open={isMaxAnswersTooltipOpen}
              showIcon={false}
            >
              <AddButton
                disableRipple
                className={classes.disabledAddButton}
                onMouseEnter={openMaxAnswersTooltip}
                onMouseLeave={closeMaxAnswersTooltip}
              />
            </InfoTooltip>
          ) : (
            <AddButton onClick={addChoice} />
          )}
          <Typography>Add New Party</Typography>
        </Grid>
      )}
    </>
  )
}

export default withStyles(styles)(FaultPercentageOptions)
